import React from 'react';
import { useParams } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import AssignmentAnswer from '@ts-core/modules/assignments/components/AssignmentAnswer';
import BackButton from '@ts-core/components/BackButton';

import { useAssignmentDetails } from '../../hooks';

const AssignmentDetailsPage = () => {
  const { courseId, assignmentId } = useParams<{ courseId: string; assignmentId: string }>();

  const { assignment, loading } = useAssignmentDetails({ courseId, assignmentId });

  return (
    <>
      <BackButton href={`/${courseId}/assignments`} title={assignment?.name} subtitle={<FormattedMessage id="quickLink.assignments" />} />
      <AssignmentAnswer assignment={assignment} loading={loading} />
    </>
  );
};

export default AssignmentDetailsPage;
